// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b07ae7a6","703":"8e164822"}[chunkId] + ".chunk.js";
};